import React from "react";
import { Link, useLocation } from "react-router-dom";
import { isAuthenticated, getSession } from "../utils/auth";

export default function DashboardSidebar({ onLogout }) {
  const location = useLocation();
  const session = isAuthenticated() ? getSession() : null;
  const isAdmin = Boolean(session?.isAdmin);
  const tab = new URLSearchParams(location.search).get("tab");

  function isActive(path, tabKey) {
    if (path === "/dashboard") {
      if (location.pathname !== "/dashboard") return false;
      if (!tabKey || tabKey === "overview") return !tab || tab === "overview";
      return tab === tabKey;
    }
    return location.pathname === path || location.pathname.startsWith(path + "/");
  }

  function navLink(to, tabKey, icon, label) {
    const basePath = to.split("?")[0];
    return (
      <Link to={to} className={`sidebar-link${isActive(basePath, tabKey) ? " active" : ""}`}>
        {icon}
        {label}
      </Link>
    );
  }

  return (
    <aside className="dash-sidebar">
      <div className="sidebar-brand">
        <img src="/assets/img/logo/logo-black.png" alt="" className="sidebar-logo" />
        <span>CH BioBank</span>
      </div>

      <nav className="sidebar-nav">
        {navLink("/dashboard", "overview",
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>,
          "Overview"
        )}
        {navLink("/dashboard?tab=submissions", "submissions",
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
          "Consent Forms"
        )}
        {navLink("/dashboard?tab=analytics", "analytics",
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>,
          "Analytics"
        )}
        {navLink("/services", null,
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>,
          "Survey Results"
        )}
        {isAdmin && navLink("/admin/users", null,
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
          "Users"
        )}
      </nav>

      <div className="sidebar-bottom">
        <Link to="/" className="sidebar-link">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
          Home
        </Link>
        <button className="sidebar-link danger" onClick={onLogout}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
          Logout
        </button>
      </div>
    </aside>
  );
}
